import { applyMiddleware, compose, createStore, type Middleware, type StoreEnhancer } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { baseApi } from './api/base-api';
import monitorReducerEnhancer from './enhancers/monitorReducer';
import loggerMiddleware from './middleware/logger';
import reducers from './reducers/rootreducer';

export default function configureStore(preloadedState?: any) {
	// baseApi.middleware is required for RTK Query lifecycle (cache, polling,
	// mutation tracking); its reducer is mounted in reducers/rootreducer.ts.
	// The cast bridges redux@4's `Middleware` type and RTK 2's (built on redux@5)
	// — same runtime shape, incompatible `action: unknown` vs `AnyAction` typings.
	const rtkQueryMiddleware = baseApi.middleware as unknown as Middleware;
	const middlewares = [loggerMiddleware, thunkMiddleware, rtkQueryMiddleware];
	const middlewareEnhancer = applyMiddleware(...middlewares);

	const enhancers = [middlewareEnhancer, monitorReducerEnhancer];
	const composedEnhancers = compose(...enhancers);

	const store = createStore(reducers, preloadedState, composedEnhancers as StoreEnhancer<unknown, {}>);

	// if (process.env.NODE_ENV !== 'production' && module.hot) {
	//     module?.hot?.accept('./reducers', () => store.replaceReducer(reducers));
	// }

	return store;
}
